import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_PERSONS,
  GET_PERSONS,
  CLEAR_PERSONS,
  SET_PERSON_INPUT_FOCUS,
  CLEAR_PERSON_INPUT_FOCUS,
  SET_FOCUS_CUSTOMER,
  CLEAR_FOCUS_CUSTOMER,
  SET_PASSENGER_LIST,
  CLEAR_PASSENGER_LIST
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
    passengerList: Immutable.List(),
  }),
  inputFocus: Immutable.Map({
    index: 0,
  }),
  customerFocus: Immutable.Map({
    focus: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_PERSONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_PERSONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PERSONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case SET_PERSON_INPUT_FOCUS:
      return state.setIn(['inputFocus', 'index'], payload);
    case CLEAR_PERSON_INPUT_FOCUS:
      return state.setIn(['inputFocus', 'index'], null);

    case SET_FOCUS_CUSTOMER:
      return state.setIn(['customerFocus', 'focus'], true);
    case CLEAR_FOCUS_CUSTOMER:
      return state.setIn(['customerFocus', 'focus'], false);

    case SET_PASSENGER_LIST:
      return state.setIn(['all', 'passengerList'], Immutable.List(payload));
    case CLEAR_PASSENGER_LIST:
      return state.setIn(['all', 'passengerList'], Immutable.List());

    default:
      return state;
  }
}